const DriveFileMove = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M800-560 640-720l56-56 104 104 104-104 56 56-160 160ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h207q16 0 30.5 6t25.5 17l57 57h320q33 0 56.5 23.5T880-640v120h-80v-120H447l-80-80H160v480h280v80H160Z" />
        </svg>
    )
}

export default DriveFileMove;

